import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translations
import translationDE from "./locales/de/translation.json";
import translationEN from "./locales/en/translation.json";
import translationRU from "./locales/ru/translation.json";
import translationAR from "./locales/ar/translation.json";

// Available languages
const resources = {
  de: { translation: translationDE },
  en: { translation: translationEN },
  ru: { translation: translationRU },
  ar: { translation: translationAR },
};

i18n
  .use(LanguageDetector) // Automatically detect browser language
  .use(initReactI18next) // Connects i18n to React
  .init({
    resources,
    fallbackLng: "de", // Fallback to German if detection fails
    lng: localStorage.getItem("i18nextLng") || "de", // Remember last used lang
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
